// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import PersonSearch20 from './PersonSearch20.tsx';
import PersonSearch24 from './PersonSearch24.tsx';
import PersonSearch40 from './PersonSearch40.tsx';
import PersonSearch48 from './PersonSearch48.tsx';

type PersonSearchProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    PersonSearch20,
    PersonSearch24,
    PersonSearch40,
    PersonSearch48,
};

const PersonSearch: FC<PersonSearchProps> = ({ variation, ...props }) => {
    const variationKey = `PersonSearch${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"PersonSearch" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default PersonSearch;
